<template>
  <transition name="fade">
    <div class="connectivity-notice" v-show="showRefreshNotice">
      <i class="fas fa-times mr-2" v-on:click="onDismiss"></i>
      <span class="ml-2">Content updated</span>
      <button v-on:click="onRefresh" class="notice ml-4">Refresh</button>
    </div>
  </transition>
</template>
<script>

import { mapState } from 'vuex'

export default {
  computed: mapState({
    showRefreshNotice: state => state.showRefreshNotice
  }),
  methods: {
    onRefresh () {
      this.$store.commit('hideRefreshNotice')
      this.$store.commit('performRefresh')
    },
    onDismiss () {
      this.$store.commit('hideRefreshNotice')
      this.$store.commit('declineRefresh')
    }
  }
}
</script>
